<template>
  <div class="header__locationDropdown">
    <!-- <span v-for="b in branch" :key="b.id" @click="$emit('getBranchId', b.id)">
      {{ b.location }}

    </span> -->

    <span @click="$emit('getBranchId', 1)"> Kathmandu </span>

    <span @click="$emit('getBranchId', 2)"> Pokhara </span>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LocationList",
  components: {},
  data() {
    return {
      branch: [],
    };
  },

  methods: {
    // getBranchId(branchId) {
    //   alert(branchId);
    // },
    getBranches() {
      axios.get("https://deus.khaanpin.com/appapi/branch").then((res) => {
        this.branch = res.data.data;
      });
    },
  },
  mounted() {
    this.getBranches();
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.header__locationDropdown {
  background-color: white;
  display: flex;
  flex-direction: column;

  position: absolute;
  box-shadow: 0 1px 3px #0000001f, 0 1px 2px #0000003d;
  width: 100%;
  opacity: 1;
  color: black;
  z-index: 9999;
  transition: all 0.8s ease;
  font-family: "Montserrat", sans-serif;

  border-radius: 3px;
  padding: 5px;
  /* min-height: 40px; */
}

.header__locationDropdown > span {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  color: rgb(131, 131, 131);
  padding: 3px 2px;
  font-weight: 200;
}

.header__locationDropdown > span:hover {
  text-decoration: underline;
}
</style>
